export default __webpack_public_path__ + "static/media/rakesh.10632675.png";